// xm-recently-viewed.js
//
// Two responsibilities:
//   1. Tracker — pushes the currently viewed product handle into localStorage when
//      the visitor is on a product page (/products/{handle}). Dedupes, max 20 kept.
//   2. <xm-recently-viewed-cross-sell> — a web component that reads the same
//      localStorage list, filters out products whose SKU is already in the cart,
//      fetches each via /products/{handle}.js and renders cart-drawer cards.

(function () {
  var STORAGE_KEY = 'xm_recently_viewed';
  var MAX_STORED = 20;

  function readList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function track() {
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return;
    var handle = match[1];
    var list = readList().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
    writeList(list);
  }

  // Standard Shopify money formatter — interprets the shop's money_format string
  // ("{{ amount }}€", "${{amount}}", "{{amount_no_decimals_with_comma_separator}} €", etc.)
  // so the cross-sell prices match the cart line-item prices EXACTLY (no "€255.00" vs "255€").
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = parseFloat(cents.replace(/[^0-9.]/g, ''));
    if (isNaN(cents) || cents == null) return '';
    var formatString = format || '{{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? (decimal + parts[1]) : '';
      return dollars + rest;
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    var value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function cardHtml(product, addLabel, moneyFormat) {
    // Pick the first available variant — fall back to first variant if none are available
    var available = (product.variants || []).filter(function (v) { return v.available; });
    var variant = available[0] || (product.variants && product.variants[0]) || {};
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var variantTitle = (variant.title && variant.title !== 'Default Title') ? variant.title : '';
    // Match product-card-horizontal.liquid structure: Title → Variant → Price,
    // then Add to cart link OUTSIDE the .v-stack (so we get the spec order:
    // Title → Variant → Price → Add to cart).
    return ''
      + '<div class="horizontal-product-card">'
      +   '<a href="' + escapeHtml(product.url) + '" class="horizontal-product-card__figure">'
      +     (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(product.title) + '" class="horizontal-product-card__image" loading="lazy">' : '')
      +   '</a>'
      +   '<div class="horizontal-product-card__info">'
      +     '<div class="v-stack gap-1 justify-items-start">'
      +       '<a href="' + escapeHtml(product.url) + '" class="product-title">' + escapeHtml(product.title) + '</a>'
      +       (variantTitle ? '<p class="xm-card-variant-title smallcaps text-subdued">' + escapeHtml(variantTitle) + '</p>' : '')
      +       '<p class="xm-card-price">' + formatMoney(variant.price, moneyFormat) + '</p>'
      +     '</div>'
      +     '<a href="javascript:void(0)" class="link text-xs xm-card-add-to-cart" data-xm-add-to-cart="' + escapeHtml(String(variant.id || '')) + '" role="button">' + escapeHtml(addLabel) + '</a>'
      +   '</div>'
      + '</div>';
  }

  // Delegated handler: clicking the cross-sell "Add to cart" link POSTs the variant to /cart/add.js
  // Affiche un état "loading" (spinner + texte ADDING…) puis "ADDED ✓" brièvement avant reset.
  if (!window.__xmRecentlyViewedAddBound) {
    window.__xmRecentlyViewedAddBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-xm-add-to-cart]');
      if (!btn) return;
      var variantId = parseInt(btn.dataset.xmAddToCart, 10);
      if (!variantId) return;
      if (btn.classList.contains('is-loading')) return; // évite double clic

      var originalText = btn.textContent;
      btn.dataset.xmOriginalText = originalText;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        // Reset état après un court délai (la cart va probablement se re-render avant de toute façon).
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        }, 1200);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      });
    });
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  var XmRecentlyViewedCrossSell = (function () {
    function Cls() {
      return Reflect.construct(HTMLElement, [], Cls);
    }
    Cls.prototype = Object.create(HTMLElement.prototype);
    Cls.prototype.constructor = Cls;
    Object.setPrototypeOf(Cls, HTMLElement);

    Cls.prototype.connectedCallback = function () {
      if (this._rendered) return;
      this._rendered = true;
      this.renderInto();
    };

    Cls.prototype.renderInto = function () {
      var self = this;
      var limit = parseInt(self.getAttribute('limit') || '5', 10);
      var cartSkus = (self.dataset.cartSkus || '').split(',').filter(Boolean);
      var excludedHandles = (self.dataset.excludedHandles || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
      var title = self.dataset.title || '';
      var stack = self.dataset.stackProducts === 'true';
      var carouselId = self.dataset.carouselId || '';
      var addLabel = self.dataset.buttonLabel || 'Add to cart';
      var fallbackTitle = self.dataset.fallbackTitle || title;
      var moneyFormat = self.dataset.moneyFormat || '{{amount}}';

      var handles = readList();
      // Drop the product currently being viewed (likely the same one we just tracked)
      var currentMatch = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      if (currentMatch) {
        handles = handles.filter(function (h) { return h !== currentMatch[1]; });
      }
      // Drop any handle blacklisted via Liquid (e.g. products in the "Sample to try" collection).
      if (excludedHandles.length) {
        handles = handles.filter(function (h) { return excludedHandles.indexOf(h) === -1; });
      }

      function buildCards(products, usedTitle) {
        // Header avec titre + boutons prev/next (matche le rendu "Manually selected products").
        var headerHtml = '';
        var hasNav = !stack && products.length > 1;
        if (usedTitle || hasNav) {
          var navHtml = '';
          if (hasNav) {
            navHtml = '<div class="cart-drawer__carousel-nav" data-xm-nav>'
              + '<button type="button" class="cart-drawer__carousel-nav-btn" data-xm-prev aria-label="Previous">'
              +   '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
              + '</button>'
              + '<button type="button" class="cart-drawer__carousel-nav-btn" data-xm-next aria-label="Next">'
              +   '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>'
              + '</button>'
              + '</div>';
          }
          headerHtml = '<div class="complementary-products__header complementary-products__header--align-start">'
            + '<p class="h6">' + usedTitle + '</p>'
            + navHtml
            + '</div>';
        }
        var cards = products.map(function (p) { return cardHtml(p, addLabel, moneyFormat); }).join('');
        var listHtml = stack
          ? '<div class="complementary-products__product-list">' + cards + '</div>'
          : '<div id="' + escapeHtml(carouselId) + '" class="complementary-products__product-list complementary-products__product-list--carousel" data-xm-carousel>' + cards + '</div>';
        self.innerHTML = headerHtml + listHtml;
        self.removeAttribute('hidden');

        // Bind prev/next → scroll d'une largeur de card.
        if (hasNav) {
          var carousel = self.querySelector('[data-xm-carousel]');
          var prevBtn = self.querySelector('[data-xm-prev]');
          var nextBtn = self.querySelector('[data-xm-next]');
          if (carousel && prevBtn && nextBtn) {
            function scrollBy(direction) {
              var step = carousel.clientWidth;
              carousel.scrollBy({ left: step * direction, behavior: 'smooth' });
            }
            prevBtn.addEventListener('click', function () { scrollBy(-1); });
            nextBtn.addEventListener('click', function () { scrollBy(1); });
            // Disable buttons when at start/end.
            function updateBtnState() {
              var maxScroll = carousel.scrollWidth - carousel.clientWidth - 1;
              prevBtn.disabled = carousel.scrollLeft <= 0;
              nextBtn.disabled = carousel.scrollLeft >= maxScroll;
            }
            updateBtnState();
            carousel.addEventListener('scroll', updateBtnState, { passive: true });
          }
        }
      }

      function filterSkuInCart(products) {
        var filtered = [];
        for (var i = 0; i < products.length && filtered.length < limit; i++) {
          var p = products[i];
          if (!p || !p.available) continue;
          if (p.handle && excludedHandles.indexOf(p.handle) !== -1) continue;
          var skus = (p.variants || []).map(function (v) { return v.sku; }).filter(Boolean);
          var hit = skus.some(function (sku) { return cartSkus.indexOf(sku) !== -1; });
          if (hit) continue;
          filtered.push(p);
        }
        return filtered;
      }

      function fetchRecommendationsFallback() {
        // Find the priciest line item in the cart, then fetch Shopify recommendations for it.
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            if (!cart || !cart.items || !cart.items.length) return;
            var priciest = cart.items[0];
            cart.items.forEach(function (i) { if (i.final_price > priciest.final_price) priciest = i; });
            var url = '/recommendations/products.json?product_id=' + priciest.product_id +
                      '&intent=complementary&limit=' + limit;
            return fetch(url, { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (data) {
                if (!data || !data.products || !data.products.length) return;
                var products = filterSkuInCart(data.products);
                if (!products.length) return;
                buildCards(products, fallbackTitle);
              });
          })
          .catch(function () {});
      }

      if (!handles.length) {
        fetchRecommendationsFallback();
        return;
      }

      Promise.all(handles.map(fetchProduct)).then(function (results) {
        var products = filterSkuInCart(results);
        if (!products.length) {
          fetchRecommendationsFallback();
          return;
        }
        buildCards(products, title);
      });
    };

    return Cls;
  })();

  if (!customElements.get('xm-recently-viewed-cross-sell')) {
    customElements.define('xm-recently-viewed-cross-sell', XmRecentlyViewedCrossSell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', track);
  } else {
    track();
  }
})();